import employees from './employees';
import expenses from './expenses';
import countries from './countries';
import quests from './quests';
import courses from './courses';
import products from './products';
import auth from './auth';
import marathons from './marathons';
import helpdesk from './helpdesk';
import demo from './demo';
import userTests from './userTests';
import cabinet from './cabinet';
import student from './student';
import profile from './profile';
import manager from './manager';
import teacher from './manager';
import offers from './offers';
import users from './users';

export default {
    employees,
    expenses,
    countries,
    quests,
    courses,
    products,
    auth,
    marathons,
    helpdesk,
    demo,
    userTests,
    cabinet,
    student,
    profile,
    manager,
    teacher,
    offers,
    users,
}



// WEBPACK FOOTER //
// ./src/api/index.js